import {
  SET_IS_SIZE_MODAL_OPEN,
  SET_FORM_FIELD,
  SET_DESIGNS,
  SET_PREVIOUS_ROUTE,
  SET_PREVIOUS_ROUTE_PARAMS,
  SET_CURRENT_STEP,
  SET_NEXT_ROUTE, SET_ADDRESS_CONFIRMED,
  SET_SIGNUP_STATE,
  SET_ADDRESS_FORM_FIELD
} from '@/utils/store/mutationTypes'

export default {
  /**
   * Sets addressConfirmed
   *
   * @param state
   * @param addressConfirmed
   */
  [SET_ADDRESS_CONFIRMED] (state, addressConfirmed) {
    state.addressConfirmed = addressConfirmed
  },

  /**
   * Sets isSizeModalOpen.
   *
   * @param state
   * @param isOpen
   */
  [SET_IS_SIZE_MODAL_OPEN] (state, { isOpen }) {
    state.isSizeModalOpen = isOpen
  },

  /**
   * Sets a field in the signup form.
   *
   * @param state
   * @param key
   * @param value
   */
  [SET_FORM_FIELD] (state, { key, value }) {
    state.form[key] = value
  },

  /**
   * Sets an address field in the signup form.
   *
   * @param state
   * @param key
   * @param value
   */
  [SET_ADDRESS_FORM_FIELD] (state, { key, value }) {
    state.form.address[key] = value
  },

  /**
   * Sets available designs.
   *
   * @param state
   * @param designs
   */
  [SET_DESIGNS] (state, { designs }) {
    state.designs = designs
  },

  /**
   * Sets current step.
   *
   * @param state
   * @param step
   */
  [SET_CURRENT_STEP] (state, { step }) {
    state.currentStep = step
  },

  /**
   * Sets previous route.
   *
   * @param state
   * @param route
   */
  [SET_PREVIOUS_ROUTE] (state, { route }) {
    state.previousRoute = route
  },

  /**
   * Sets previous route params.
   *
   * @param state
   * @param params
   */
  [SET_PREVIOUS_ROUTE_PARAMS] (state, { params = {} }) {
    state.previousRouteParams = params
  },

  /**
   * Sets next route.
   *
   * @param state
   * @param route i18n.localePath
   */
  [SET_NEXT_ROUTE] (state, { route }) {
    state.nextRoute = route
  },

  /**
   * Set signup state
   *
   * @param state
   * @param variables
   */
  [SET_SIGNUP_STATE] (state, variables) {
    const { form = {}, addressConfirmed = false, isSizeModalOpen = false, designs = {}, currentStep = 0, previousRoute = '', nextRoute = '', streetType = '' } = variables

    state.form = form
    state.addressConfirmed = addressConfirmed
    state.isSizeModalOpen = isSizeModalOpen
    state.designs = designs
    state.currentStep = currentStep
    state.previousRoute = previousRoute
    state.streetType = streetType
    state.nextRoute = nextRoute
  }
}
